const state = {
  searchTitle: 'Find the right HTS Code',
  searchSubtitle:
    'Submit your requirements and get the best quotes from verified Rice suppliers',
  pageTitle: '',
  metaDescription: '',
  pageType: 'main-landing'
}

const mutations = {
  SET_CONTENTFUL_TITLES(state, payload) {
    state.searchTitle = payload.searchTitle
    state.searchSubtitle = payload.searchSubtitle
    state.pageType = payload.pageType
    state.pageTitle = payload.pageTitle
    state.metaDescription = payload.metaDescription
  }
}

const actions = {
  setContentfulTitles({ commit }, payload) {
    commit('SET_CONTENTFUL_TITLES', payload)
  }
}

const getters = {
  contentfulData: (state) => state
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
